module.exports = __webpack_public_path__ + "static/img/huawei.f7fea588.svg";